angular
  .module 'filters'
  .filter 'membershipPlanCategoryFilter', ->
    (category) ->
      category || 'N/A'
